import { useState, useEffect } from "react"

import { IMember } from "@cloudike/web_photos/dist/types/intarfaces/IMember"
import { useAppDispatch, useAppSelector } from "shared/config/store"
import { deleteFamilyMembersThunk, fetchFamilyThunk, updateFamilyMemberRoleThunk } from "features/team/model/slice/teamSlice"
import {
  realFamilyMembersWithAvatarsSelector
} from 'features/team/model/selectors/teamSelectors'
import { NOTIFICATION_TYPES, showNotification } from "features/common/notifications"

export const useManageMembers = () => {
  const dispatch = useAppDispatch()
  const teamMembers = useAppSelector(realFamilyMembersWithAvatarsSelector)

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false)
  const [selectedMember, setSelectedMember] = useState<IMember | null>(null)

  useEffect(() => {
    dispatch(fetchFamilyThunk())
  }, [dispatch])

  const showDeleteConfirmation = (member: IMember) => {
    setSelectedMember(member)
    setIsConfirmationModalOpen(true)
  }

  const handleConfirmDelete = () => {
    if (selectedMember) {
      dispatch(deleteFamilyMembersThunk([selectedMember]))
    }
    setIsConfirmationModalOpen(false)
  }

  const handleChangeRole = async (member: IMember, newRole: string) => {
    try {
      dispatch(updateFamilyMemberRoleThunk({ member, role: newRole }))

    } catch (error) {
      showNotification({
        type: NOTIFICATION_TYPES.ERROR,
        title: 'Role update failed',
        message: 'Failed to update member role',
      })
    }
  }

  return {
    teamMembers,
    isConfirmationModalOpen,
    selectedMember,
    showDeleteConfirmation,
    handleConfirmDelete,
    handleChangeRole,
    closeModal: () => setIsConfirmationModalOpen(false),
  }
}
